module.exports = {"baseQuery":"","defaultSort":[{"id":"ModifiedOnDateTime","desc":true}],"ignoreFields":[]}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/datagrids/incident209Resources.json
// module id = 1673
// module chunks = 0